import { useState } from "react";
import { useDispatch } from "react-redux";
import WarningAlertIcon from "../Assets/svgs/WarningAlertIcon";
import PaginatedDropdown from "../Common/PaginatedDropdown";
import { getPlanTypeList } from "../Redux/Slice/PlanType/GetPlanTypeListSlice";
import { Loader } from "../Common/Loader";
import { linkAndDeletePlanType } from "../Redux/Slice/PlanType/LinkAndDeletePlanTypeSlice";
import useSuccessErrorAlert from "../Hooks/useSuccessErrorAlert";
import { SuccessModel } from "./SuccessModel";
import { ErrorModel } from "./ErrorModel";
import CloseIcon from "../Assets/svgs/CloseIcon";

const DeletePlanTypeModal = ({
  onClose,
  onSuccess,
  selectedPlanTypeForDeletion,
}) => {
  const dispatch = useDispatch();
  const [planType, setPlanType] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { successModal, errorModal, showSuccessMessage, showErrorMessage } =
    useSuccessErrorAlert();

  const onSelectPlanType = (planType) => {
    setPlanType(planType);
  };

  const loadPlanTypeOptions = async (
    search,
    loadedOptions,
    { page, limit }
  ) => {
    const result = await dispatch(
      getPlanTypeList({ searchText: search, page, limit })
    );
    const totalPages = result?.payload?.pagination?.totalPages;
    const options = Array.isArray(result?.payload?.data)
      ? result?.payload?.data
          ?.map((planType) => ({
            ...planType,
            label: planType?.type,
            value: planType?.id,
          }))
          .filter(
            (planType) => planType?.value != selectedPlanTypeForDeletion?.id
          )
      : [];

    return {
      options: options,
      hasMore:
        !options || !options?.length || page == totalPages ? false : true,
      additional: {
        page: page + 1,
      },
    };
  };

  const onClickDeletePlanType = async () => {
    setIsLoading(true);
    const payload = {
      planTypeId: selectedPlanTypeForDeletion?.id,
      body: {
        addPlanTypeId: planType?.id,
      },
    };
    const result = await dispatch(linkAndDeletePlanType(payload));
    setIsLoading(false);
    if (
      linkAndDeletePlanType.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      showSuccessMessage("Plan Type deleted successfully!", onSuccess);
    } else {
      showErrorMessage(result?.payload?.data?.message);
    }
  };

  if (isLoading) {
    return <Loader />;
  } else if (successModal.visible) {
    return <SuccessModel message={successModal.message} />;
  } else if (errorModal.visible) {
    return <ErrorModel message={errorModal.message} />;
  }

  return (
    <div className="modal modal--modalCredits modal--open">
      <div className="modal__dialog">
        <div className="modal__content modal__content--md">
          <div class="modal__header">
            <button className="btn btn__transparent btnClose" onClick={onClose}>
              <CloseIcon />
            </button>
          </div>
          <div className="modal__body">
            <span className="icon icon--mb5">
              <WarningAlertIcon />
            </span>
            <h4 className="title title--h3 title--black">Delete Plan Type?</h4>
            <p className="para para--mb5">
              The selected plan type is currently linked to one or more plans.
              To delete it, please choose a new plan type to reassign those
              plans.
            </p>
            <div className="formRow mb_0">
              <div className="formCol">
                <div className="form__Field">
                  <label for="plansType" className="form__label">
                    New Plan Type
                    <span style={{ color: "red" }}> * </span>
                  </label>
                  <div style={{ textAlign: "justify" }}>
                    <PaginatedDropdown
                      value={planType}
                      loadOptions={loadPlanTypeOptions}
                      onChange={onSelectPlanType}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal__footer">
            <div className="btn__group">
              <button className="btn btn__white btn--full" onClick={onClose}>
                Cancel
              </button>
              <button
                className="btn btn__danger btn--full"
                disabled={!planType?.id}
                onClick={onClickDeletePlanType}
              >
                Link & Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};

export default DeletePlanTypeModal;
